module.exports = __webpack_public_path__ + "static/media/3DPPA14.0f22477c.jpg";